import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import { Reveal } from "@/components/Reveal";
import { FAQSection } from "@/components/FAQSection";
import { SEO } from "@/components/SEO";

const TITLES = {
  it: { title: "Domande frequenti su Bellagio e il B&B", sub: "Tutto quello che ti serve sapere su Bellagio, parcheggi, battelli e il tuo soggiorno." },
  en: { title: "Frequently asked questions about Bellagio", sub: "Everything you need to know about Bellagio, parking, ferries and your stay." },
  fr: { title: "Questions fréquentes sur Bellagio", sub: "Tout ce qu'il faut savoir sur Bellagio, parking, bateaux et votre séjour." }
};

export default function FAQPage() {
  const { lang } = useI18n();
  const t = TITLES[lang] || TITLES.it;
  return (
    <>
      <SEO pathKey="/faq" />
      <section className="pt-36 pb-12 bg-[#F2EFEB]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal>
            <h1 className="font-display text-5xl md:text-6xl text-[#1A1A1A] tracking-tight">{t.title}</h1>
            <p className="mt-5 text-lg text-[#5C5C5C] max-w-2xl">{t.sub}</p>
          </Reveal>
        </div>
      </section>
      <FAQSection />
    </>
  );
}
